export default {
  toggled: false,
}
